import React, { useEffect, useState } from 'react';
import VisualizacaoDeckDetalhada from './visualizador';
import { useParams } from 'react-router-dom';
import DeckDB from '../../database/wrappers/deck';


const DeckPreview = () => {
	const { id } = useParams();
	const [deck, setDeck] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const loadDeck = async () => {
			const db = new DeckDB();

			try {
				const result = await db.get(id);

				if (result) {
					setDeck(result);
				} else {
					console.warn('Deck não encontrado.');
				}
			} catch (error) {
				console.error('Erro ao carregar o deck:', error);
			} finally {
				setLoading(false);
			}
		};

		if (id) loadDeck();
	}, [id]);

	if (loading) return <div className="text-slate-300 p-4 mt-16">Carregando deck...</div>;
	if (!deck) return <div className="text-red-400 p-4 mt-16">Deck não encontrado.</div>;

	return (
		<div className=" ">
			<VisualizacaoDeckDetalhada deck={deck} />
		</div>
	);
};

export default DeckPreview;
